import Flatpickr from "stimulus-flatpickr"

export default class FlatpickrDateController extends Flatpickr {
  connect() {
    this.config = {
      ...this.config, //spread options in case some where defined in initialize
      altInput: true,
      altFormat: "F j, Y",
      dateFormat: "Y-m-d",
      position: "auto center"
    };

    super.connect();
  }
}
